// extracted by css-extract-rspack-plugin
export default {"root":"root-BQgj5B","full":"full-_SoJzq","center":"center-MJI6CG"};